import React, { useEffect } from 'react';
import { postApi } from '../../apiUtils';
import { useBreadcrumbs } from '../../contexts/breadcrumbsContext';
import { useLoading } from '../../contexts/loadingContext';
import { useTranslation } from '../../contexts/translation';
import { TerminalMappingForm } from '../../forms/terminalMapping/TerminalMappingForm';
import { PageContentWrapper } from '../../layouts/contentWrapper/PageContentWrapper';
import { TerminalMappingCreateInput } from '../../types/terminalMapping.types';
import { API_URL } from '../../utils/apiUrl';

export const TerminalMappingNew = () => {
  const { translate } = useTranslation();
  const transFormName = 'TerminalMapping.Create';
  const { startLoading, stopLoading } = useLoading();
  const { setValue } = useBreadcrumbs();

  useEffect(() => {
    setValue({
      pageName: 'New terminal mapping',
      steps: [
        { name: 'Home', pathToCutCount: 3 },
        { name: 'Terminal mapping', pathToCutCount: 2 },
      ],
    });
    return () => {
      setValue(null);
    };
  }, []);

  const formData: TerminalMappingCreateInput = {
    ip: '',
    defaultAssetClass: null,
    defaultUserId: null,
    assignedAssetId: null,
    description: null,
  };

  const onSubmit = async (e) => {
    if (e !== null) e.preventDefault();
    let isOk = false;
    startLoading();
    await postApi<TerminalMappingCreateInput>({
      url: API_URL.TERMINAL_MAPPING_CREATE,
      data: formData,
      callAfterSuccess: () => {
        isOk = true;
      },
    });
    stopLoading();
    return isOk;
  };

  return (
    <PageContentWrapper heading={translate!('New terminal mapping', transFormName)}>
      <TerminalMappingForm onSubmit={onSubmit} formData={formData} />
    </PageContentWrapper>
  );
};
